import * as R from 'ramda';

/**
 * A redux thunk-creator that sets a query parameter via an action e.g. a
 * filter.
 * @param {Object} filters - Query params in key/val format.
 * @param {Array} [omittedFilters] - Filters to omit from the final result.
 * Useful if `merge` argument is true, but some parameters should be omitted
 * (e.g. current `page` should be omitted when setting new `geography` filter).
 * @param {Boolean} [merge] - If parameters should overwrite existing ones or
 * be merged in.
 * @param {Array} [thunks] - Any thunks that should be run post-filter.
 * Provides a way of opting in/out of potentially re-fetching data when the
 * filters don't apply to every bit of async data in the thunk.
 * @returns {Thunk}
 * @example
 * dispatch(setFilter({
 *   sort: by,
 *   order: dir,
 * }, ['page']))
 */
const setFilter = (filters, omittedFilters = [], merge, thunks) => (
  (dispatch, getState) => {
    const state = getState();

    dispatch({
      type: R.path(['location', 'type'], state),
      payload: R.path(['location', 'payload'], state),
      thunks,
      query: R.pipe(
        R.ifElse(
          R.always(R.equals(merge, true)),
          R.merge(R.path(['location', 'query'], state)),
          R.always(R.or(filters, R.path(['location', 'query'], state))),
        ),
        R.omit(omittedFilters),
        R.reject(R.isNil),
      )(filters),
    });
  }
);

export default setFilter;
